import Component from '../../shared/component';

export default class ResponsivePlaceholder extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.currentPageFormat = 'desktop';

    this.bindEvents();
    this.handleResize();
  }

  bindEvents() {
    this.handleResize = this.handleResize.bind(this);

    window.$window.on('resize.Placeholder', this.handleResize);
  }

  unbindEvents() {
    window.$window.off('resize.Placeholder', this.handleResize);
  }

  handleResize() {
    this.checkPageFormat();

    if (this.oldPageFormat !== this.currentPageFormat) {
      if (this.currentPageFormat === 'desktop') {
        this.$element.attr(
          'placeholder',
          this.$element.data('placeholder-long')
        );
      } else {
        this.$element.attr(
          'placeholder',
          this.$element.data('placeholder-short')
        );
      }
    }
  }

  checkPageFormat() {
    this.oldPageFormat = this.currentPageFormat;

    if (window.$window.width() > window.pageContentWidthSm) {
      this.currentPageFormat = 'desktop';
    } else {
      this.currentPageFormat = 'mobile';
    }
  }
}
